import * as React from 'react';
import axios from "axios";
import { useState, useContext } from 'react';
import { AuthContext } from "../Auth/AuthContext";
import Button from '@mui/material/Button';
import { SvgIcon } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from "react-i18next";
import { useSnackbar } from 'notistack';
import {deleteFileS3,deleteProductS3,isViewerReady,isViewerError} from "../utils/interfaceS3";

export default function DeleteFileDialog({ setOpen, open, data, reloadProjects }) {

    const {  t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(false);
    const {jwt,user,idToken, region, idpool} = useContext(AuthContext);

    const handleClose = () => {
        setOpen(false);
    };

    //check if LOD has been done, or if the LOD processing has finished in error
    async function isFileReadyForDeletion()
    {
        let viewerReady = await isViewerReady(user.sub,idToken, region, idpool,`${data.attributes.filename}`);
        let viewerError = await isViewerError(user.sub,idToken, region, idpool,`${data.attributes.filename}`);

        return viewerReady || viewerError;
    }

    const deleteEntry = async value => {
        setIsLoading(true);
        //console.log(data);

        const ready = await isFileReadyForDeletion();
        if(!ready){
            enqueueSnackbar(`${t("FileNotReadyForDeletion")}`, {variant:'warning'} );
            setIsLoading(false);
            return; 
        }

        // Delete associated result files from S3
        const results = data.attributes.results?.data || [];
        for (const result of results) {
            const apiUrl = `${global.API_URL}/api/results/${result.id}`;
            await axios.delete(apiUrl, {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                }
            });
            const filenameWithExt = result.attributes.filename.split('/').pop();
            await deleteProductS3(user.sub, idToken, region, idpool, filenameWithExt);
        }

        await deleteFileS3(user.sub,idToken, region, idpool,`${data.attributes.filename}`);
        const apiUrl = `${global.API_URL}/api/datas/${data.id}`;
        axios.delete(apiUrl, {
            headers: {
                Authorization: `Bearer ${jwt}`,
            }
        })
            .then(res => {
                setIsLoading(false);
                enqueueSnackbar(`${t("successDeleteFile")}`, {variant:'success'} );
                setOpen(false);
                reloadProjects();             
            })
            .catch(err => {
                setIsLoading(false);
                enqueueSnackbar(`${t("errorDeleteFile")}`, {variant:'error'} );
            });
    }

    return (

        <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth={true}>
            <Box sx={{ p: 3 }}>
                <DialogTitle>
                    <Typography variant="h4" component={"div"}>
                        {t("DeleteFile")}
                    </Typography>
                </DialogTitle>
                <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 16,
                    top: 16,
                    color: theme.palette.grey[500],
                })}
                >
                <CancelIcon />
                </IconButton>
                <DialogContent>
                    <DialogContentText component={"div"}>
                        <Typography
                            color="text.secondary"
                            variant="body2"
                        >
                            {t("DeleteFileDesc")}
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                    startIcon={(
                        <SvgIcon fontSize="medium">
                            <DeleteIcon />
                        </SvgIcon>
                    )} 
                    variant="contained" color="error" onClick={deleteEntry}>{isLoading ? `${t("Deleting")} ...` : `${t("Delete")}`}</Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}